// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".services-payment[data-v-60dbaa59]{display:-webkit-box;display:-ms-flexbox;display:flex}.services-payment strong[data-v-60dbaa59]{margin:auto 0}.services-payment .payment-select[data-v-60dbaa59]{width:36%}.services-payment button[data-v-60dbaa59]{border:1px solid #5b2ae0}", ""]);
// Exports
module.exports = exports;
